// MG Product Swatches export: Bloom color and size editor sections
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-Bloom2oz"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f7f4ec",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "wrap_text",
      "text_size_mobile": 12,
      "text_size_desktop": 13,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 0,
      "gradient_color": "#f7f4ec",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "wrap_text",
      "text_size_mobile": 12,
      "text_size_desktop": 13,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 0,
      "gradient_color": "#f7f4ec",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--28071284506758__bloom_colors_2oz-0",
      "custom_html": "<span hidden data-bloom-compact-colors></span><style>:is([data-mg-set=\"Colors-Bloom2oz\"],[data-mg-set=\"Colors-Bloom4pk\"],[data-mg-set$=\"-bloom_colors\"],.mgps-modal:has(img[src*=\"Swatch-DPF\"])) .mgps-img-wrap{--mgps-row-aspect:1000 / 443!important;aspect-ratio:1000 / 443!important;height:auto!important;min-height:0!important}:is([data-mg-set=\"Colors-Bloom2oz\"],[data-mg-set=\"Colors-Bloom4pk\"],[data-mg-set$=\"-bloom_colors\"],.mgps-modal:has(img[src*=\"Swatch-DPF\"])) .mgps-img-inner img{aspect-ratio:1000 / 443!important;object-fit:contain!important}.mgps-row:has([data-bloom-compact-colors]){display:none!important}</style><style data-bloom-mobile-sizing>@media(max-width:749px){[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__inner{min-height:116px!important;padding:12px 16px!important;gap:16px!important;align-items:center!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__media{width:88px!important;height:88px!important;min-width:88px!important;flex:0 0 88px!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__image{width:100%!important;height:100%!important;object-fit:contain!important;aspect-ratio:auto!important;transform:none!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__body{min-width:0!important;flex:1 1 auto!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__label{font-size:16px!important;line-height:1.35!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__hint{font-size:14px!important;line-height:1.4!important}}</style><style data-ri29-centered-colors>.mgps-modal:has([data-bloom-compact-colors]){align-items:center!important;justify-content:center!important;padding-block:16px!important;box-sizing:border-box!important}.mgps-modal:has([data-bloom-compact-colors]) .mgps-modal__dialog{max-height:calc(100vh - 32px)!important;max-height:calc(100dvh - 32px)!important;margin:0!important}.mgps-modal:has([data-bloom-compact-colors]) .mgps-modal__body{min-height:0!important;max-height:calc(100vh - 32px)!important;max-height:calc(100dvh - 32px)!important;overflow:auto!important;overscroll-behavior:contain}.mgps-modal:has([data-bloom-compact-colors]) .mgps-thumb-row[data-swatch-row=\"true\"]{justify-content:center!important}</style>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": "0",
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "heading": "<h2>Bloom colors</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 4,
      "swatches_per_row_desktop": 6,
      "swatches_per_row": 6,
      "padding_between_rows_mobile": 8,
      "padding_between_rows_desktop": 8,
      "padding_between_rows": 8,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gesso Cloud White",
          "alt": "Gesso Cloud White",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF01_Gesso-Cloud-White.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF01-GESSO-CLOUD-WHITE.jpg?v=1792614483&width=400",
          "product_url": "/products/bloom_dpf01-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf01-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Desert Petal",
          "alt": "Desert Petal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF02_Desert-Petal.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF02-DESERT-PETAL.jpg?v=1792614484&width=400",
          "product_url": "/products/bloom_dpf02-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf02-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Carmine Ember",
          "alt": "Carmine Ember",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF03_Carmine-Ember.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF03-CARMINE-EMBER.jpg?v=1792614485&width=400",
          "product_url": "/products/bloom_dpf03-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf03-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bloodstone Clay",
          "alt": "Bloodstone Clay",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF04_Bloodstone-Clay.png?v=1793132176&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF04-BLOODSTONE-CLAY.jpg?v=1792614486&width=400",
          "product_url": "/products/bloom_dpf04-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf04-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Molten Ochre",
          "alt": "Molten Ochre",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF05_Molten-Ochre.png?v=1793132179&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF05-MOLTEN-OCHRE.jpg?v=1792614488&width=400",
          "product_url": "/products/bloom_dpf05-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf05-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Relic",
          "alt": "Sun Relic",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF06_Sun-Relic.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF06-SUN-RELIC.jpg?v=1792614488&width=400",
          "product_url": "/products/bloom_dpf06-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf06-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Burnished Earth",
          "alt": "Burnished Earth",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF07_Burnished-Earth.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF07-BURNISHED-EARTH.jpg?v=1792614489&width=400",
          "product_url": "/products/bloom_dpf07-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf07-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Acid Moss",
          "alt": "Acid Moss",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF08_Acid-Moss.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF08-ACID-MOSS.jpg?v=1792614490&width=400",
          "product_url": "/products/bloom_dpf08-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf08-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Verdant Pulse",
          "alt": "Verdant Pulse",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF09_Verdant-Pulse.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF09-VERDANT-PULSE.jpg?v=1792614491&width=400",
          "product_url": "/products/bloom_dpf09-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf09-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Mint Green",
          "alt": "Mint Green",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF10_Mint-Green.png?v=1793132179&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF10-MINT-GREEN.jpg?v=1792614492&width=400",
          "product_url": "/products/bloom_dpf10-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf10-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Meadow Veil",
          "alt": "Meadow Veil",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF11_Meadow-Veil.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF11-MEADOW-VEIL.jpg?v=1792614493&width=400",
          "product_url": "/products/bloom_dpf11-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf11-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<p>View All</p>",
          "button_style": "swatch",
          "button_appearance_source": "inherit_from_parent",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": "4",
          "popup_swatches_per_row_desktop": "6",
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#cfcfcf",
          "preset_button_border_size": 2,
          "preset_button_shadow_size": 4,
          "preset_button_border_radius_px": 6,
          "preset_button_background_color": "#f7f4ec",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#f7f4ec",
          "preset_button_gradient_angle": 42,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 13,
          "preset_button_text_size_desktop": 14,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 6,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Bloom-View-All-Textured-20261027.png?v=1793136985&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Bloom-View-All-Textured-20261027.png?v=1793136985&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Emerald Forest",
          "alt": "Emerald Forest",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF12_Emerald-Forest.png?v=1793132176&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF12-EMERALD-FOREST.jpg?v=1792614494&width=400",
          "product_url": "/products/bloom_dpf12-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf12-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Herbal Stone",
          "alt": "Herbal Stone",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF13_Herbal-Stone.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF13-HERBAL-STONE.jpg?v=1792614496&width=400",
          "product_url": "/products/bloom_dpf13-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf13-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Patina Teal",
          "alt": "Patina Teal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF14_Patina-Teal.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF14-PATINA-TEAL.jpg?v=1792614496&width=400",
          "product_url": "/products/bloom_dpf14-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf14-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ultramarine Lift",
          "alt": "Ultramarine Lift",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF15_Ultramarine-Lift.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF15-ULTRAMARINE-LIFT.jpg?v=1792614497&width=400",
          "product_url": "/products/bloom_dpf15-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf15-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Prussian Depths",
          "alt": "Prussian Depths",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF16_Prussian-Depths.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF16-PRUSSIAN-DEPTHS.jpg?v=1792614498&width=400",
          "product_url": "/products/bloom_dpf16-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf16-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Mystic Plum",
          "alt": "Mystic Plum",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF17_Mystic-Plum.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF17-MYSTIC-PLUM.jpg?v=1792614499&width=400",
          "product_url": "/products/bloom_dpf17-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf17-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Lavender Ash",
          "alt": "Lavender Ash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF18_Lavender-Ash.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF18-LAVENDER-ASH.jpg?v=1792614501&width=400",
          "product_url": "/products/bloom_dpf18-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf18-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bloomed Violet",
          "alt": "Bloomed Violet",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF19_Bloomed-Violet.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF19-BLOOMED-VIOLET.jpg?v=1792614502&width=400",
          "product_url": "/products/bloom_dpf19-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf19-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Royal Orchid",
          "alt": "Royal Orchid",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF20_Royal-Orchid.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF20-ROYAL-ORCHID.jpg?v=1792614503&width=400",
          "product_url": "/products/bloom_dpf20-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf20-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Desert Drift",
          "alt": "Desert Drift",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF21_Desert-Drift.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF21-ESERT-DRIFT.jpg?v=1792614505&width=400",
          "product_url": "/products/bloom_dpf21-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf21-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearthgrain",
          "alt": "Hearthgrain",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF22_Hearthgrain.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF22-HEARTHGRAIN_1.jpg?v=1792614505&width=400",
          "product_url": "/products/bloom_dpf22-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf22-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Battlefield Soil",
          "alt": "Battlefield Soil",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF23_Battlefield-Soil.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF23-BATTLEFIELD-SOIL.jpg?v=1792614506&width=400",
          "product_url": "/products/bloom_dpf23-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf23-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Carbon Void Black",
          "alt": "Carbon Void Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Carbon-Void-Black_51f8da94-6d8b-4d8b-9e65-d6728a653555.png?v=1793132174&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_2D.png?v=1792764175&width=400",
          "product_url": "/products/bloom_dpf24-30_xxs",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf24-30_xxs",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-Bloom4pk"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f7f4ec",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "wrap_text",
      "text_size_mobile": 12,
      "text_size_desktop": 13,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 0,
      "gradient_color": "#f7f4ec",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "wrap_text",
      "text_size_mobile": 12,
      "text_size_desktop": 13,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 0,
      "gradient_color": "#f7f4ec",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--28071284506758__bloom_colors_4pk-0",
      "custom_html": "<span hidden data-bloom-compact-colors></span><style>:is([data-mg-set=\"Colors-Bloom2oz\"],[data-mg-set=\"Colors-Bloom4pk\"],[data-mg-set$=\"-bloom_colors\"],.mgps-modal:has(img[src*=\"Swatch-DPF\"])) .mgps-img-wrap{--mgps-row-aspect:1000 / 443!important;aspect-ratio:1000 / 443!important;height:auto!important;min-height:0!important}:is([data-mg-set=\"Colors-Bloom2oz\"],[data-mg-set=\"Colors-Bloom4pk\"],[data-mg-set$=\"-bloom_colors\"],.mgps-modal:has(img[src*=\"Swatch-DPF\"])) .mgps-img-inner img{aspect-ratio:1000 / 443!important;object-fit:contain!important}.mgps-row:has([data-bloom-compact-colors]){display:none!important}</style><style data-bloom-mobile-sizing>@media(max-width:749px){[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__inner{min-height:116px!important;padding:12px 16px!important;gap:16px!important;align-items:center!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__media{width:88px!important;height:88px!important;min-width:88px!important;flex:0 0 88px!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__image{width:100%!important;height:100%!important;object-fit:contain!important;aspect-ratio:auto!important;transform:none!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__body{min-width:0!important;flex:1 1 auto!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__label{font-size:16px!important;line-height:1.35!important}[data-mg-set$=\"-bloom_sizes\"] .mgps-preset-btn--product_image_button .mgps-preset-btn__hint{font-size:14px!important;line-height:1.4!important}}</style><style data-ri29-centered-colors>.mgps-modal:has([data-bloom-compact-colors]){align-items:center!important;justify-content:center!important;padding-block:16px!important;box-sizing:border-box!important}.mgps-modal:has([data-bloom-compact-colors]) .mgps-modal__dialog{max-height:calc(100vh - 32px)!important;max-height:calc(100dvh - 32px)!important;margin:0!important}.mgps-modal:has([data-bloom-compact-colors]) .mgps-modal__body{min-height:0!important;max-height:calc(100vh - 32px)!important;max-height:calc(100dvh - 32px)!important;overflow:auto!important;overscroll-behavior:contain}.mgps-modal:has([data-bloom-compact-colors]) .mgps-thumb-row[data-swatch-row=\"true\"]{justify-content:center!important}</style>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": "0",
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "heading": "<h2>Bloom colors</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 4,
      "swatches_per_row_desktop": 6,
      "swatches_per_row": 6,
      "padding_between_rows_mobile": 8,
      "padding_between_rows_desktop": 8,
      "padding_between_rows": 8,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Gesso Cloud White",
          "alt": "Gesso Cloud White",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF01_Gesso-Cloud-White.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF01_Gesso-Cloud-White_4pk_Front_2D.png?v=1792767745&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-gesso-cloud-white",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-gesso-cloud-white",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Desert Petal",
          "alt": "Desert Petal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF02_Desert-Petal.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF02_Desert-Petal_4pk_Front_2D.png?v=1792766295&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-desert-petal",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-desert-petal",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Carmine Ember",
          "alt": "Carmine Ember",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF03_Carmine-Ember.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF03_Carmine-Ember_4pk_Front_2D.png?v=1792767863&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-carmine-ember",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-carmine-ember",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bloodstone Clay",
          "alt": "Bloodstone Clay",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF04_Bloodstone-Clay.png?v=1793132176&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF04_Bloodstone-Clay_4pk_Front_2D.png?v=1792768012&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-bloodstone-clay",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-bloodstone-clay",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Molten Ochre",
          "alt": "Molten Ochre",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF05_Molten-Ochre.png?v=1793132179&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF05_Molten-Ochrey_4pk_Front_2D.png?v=1792768100&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-molten-ochre",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-molten-ochre",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Relic",
          "alt": "Sun Relic",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF06_Sun-Relic.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF06_Sun-Relic_4pk_Front_2D.png?v=1792768176&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-sun-relic",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-sun-relic",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Burnished Earth",
          "alt": "Burnished Earth",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF07_Burnished-Earth.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF07_Burnished-Earth_4pk_Front_2D.png?v=1792768234&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-burnished-earth",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-burnished-earth",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Acid Moss",
          "alt": "Acid Moss",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF08_Acid-Moss.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/4pk_Front_2D.png?v=1792764718&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-acid-moss",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-acid-moss",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Verdant Pulse",
          "alt": "Verdant Pulse",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF09_Verdant-Pulse.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF09_Verdant-Pulse_4pk_Front_2D.png?v=1792768309&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-verdant-pulse",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-verdant-pulse",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Mint Green",
          "alt": "Mint Green",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF10_Mint-Green.png?v=1793132179&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF10_Mint-Green_4pk_Front_2D.png?v=1792768387&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-mint-green",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-mint-green",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Meadow Veil",
          "alt": "Meadow Veil",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF11_Meadow-Veil.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF11_Meadow-Veil_4pk_Front_2D.png?v=1792768474&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-meadow-veil",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-meadow-veil",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<p>View All</p>",
          "button_style": "swatch",
          "button_appearance_source": "inherit_from_parent",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": "4",
          "popup_swatches_per_row_desktop": "6",
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#cfcfcf",
          "preset_button_border_size": 2,
          "preset_button_shadow_size": 4,
          "preset_button_border_radius_px": 6,
          "preset_button_background_color": "#f7f4ec",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#f7f4ec",
          "preset_button_gradient_angle": 42,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 13,
          "preset_button_text_size_desktop": 14,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 6,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Bloom-View-All-Textured-20261027.png?v=1793136985&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Bloom-View-All-Textured-20261027.png?v=1793136985&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Emerald Forest",
          "alt": "Emerald Forest",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF12_Emerald-Forest.png?v=1793132176&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF12_Emerald-Forest_4pk_Front_2D.png?v=1792768533&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-emerald-forest",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-emerald-forest",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Herbal Stone",
          "alt": "Herbal Stone",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF13_Herbal-Stone.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF13_Herbal-Stone_4pk_Front_2D.png?v=1792768618&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-herbal-stone",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-herbal-stone",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Patina Teal",
          "alt": "Patina Teal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF14_Patina-Teal.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF14_Patina-Teal_4pk_Front_2D.png?v=1792768685&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-patina-teal",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-patina-teal",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Ultramarine Lift",
          "alt": "Ultramarine Lift",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF15_Ultramarine-Lift.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF15_Ultramarine-Lift_4pk_Front_2D.png?v=1792768757&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-ultramarine-lift",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-ultramarine-lift",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Prussian Depths",
          "alt": "Prussian Depths",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF16_Prussian-Depths.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF16_Prussian-Depths_4pk_Front_2D.png?v=1792768816&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-prussian-depths",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-prussian-depths",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Mystic Plum",
          "alt": "Mystic Plum",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF17_Mystic-Plum.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF17_Mystic-Plum_4pk_Front_2D.png?v=1792768880&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-mystic-plum",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-mystic-plum",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Lavender Ash",
          "alt": "Lavender Ash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF18_Lavender-Ash.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF18_Lavender-Ash_4pk_Front_2D.png?v=1792768957&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-lavender-ash",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-lavender-ash",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bloomed Violet",
          "alt": "Bloomed Violet",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF19_Bloomed-Violet.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF19_Bloomed-Violet_4pk_Front_2D.png?v=1792769027&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-bloomed-violet",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-bloomed-violet",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Royal Orchid",
          "alt": "Royal Orchid",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF20_Royal-Orchid.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF20_Royal-Orchid_4pk_Front_2D.png?v=1792769085&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-royal-orchid",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-royal-orchid",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Desert Drift",
          "alt": "Desert Drift",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF21_Desert-Drift.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF21_Desert-Drift_4pk_Front_2D.png?v=1792769148&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-desert-drift",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-desert-drift",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearthgrain",
          "alt": "Hearthgrain",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF22_Hearthgrain.png?v=1793132178&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF22_Hearthgrain_4pk_Front_2D.png?v=1792769225&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-hearthgrain",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-hearthgrain",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Battlefield Soil",
          "alt": "Battlefield Soil",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-DPF23_Battlefield-Soil.png?v=1793132177&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/4pk_Front_2D_70febbcd-552d-438f-a215-64c762fc8236.png?v=1792765004&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-battlefield-soil",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-battlefield-soil",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Carbon Void Black",
          "alt": "Carbon Void Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Carbon-Void-Black_51f8da94-6d8b-4d8b-9e65-d6728a653555.png?v=1793132174&width=400",
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF24_Carbon-Void-Black_4pk_Front_2D.png?v=1792769279&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-carbon-void-black",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-carbon-void-black",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-gesso-cloud-white"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF01-GESSO-CLOUD-WHITE.jpg?v=1792614483&width=400",
          "product_url": "/products/bloom_dpf01-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf01-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF01_Gesso-Cloud-White_4pk_Front_2D.png?v=1792767745&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-gesso-cloud-white",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-gesso-cloud-white",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-desert-petal"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF02-DESERT-PETAL.jpg?v=1792614484&width=400",
          "product_url": "/products/bloom_dpf02-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf02-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF02_Desert-Petal_4pk_Front_2D.png?v=1792766295&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-desert-petal",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-desert-petal",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-carmine-ember"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF03-CARMINE-EMBER.jpg?v=1792614485&width=400",
          "product_url": "/products/bloom_dpf03-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf03-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF03_Carmine-Ember_4pk_Front_2D.png?v=1792767863&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-carmine-ember",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-carmine-ember",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-bloodstone-clay"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF04-BLOODSTONE-CLAY.jpg?v=1792614486&width=400",
          "product_url": "/products/bloom_dpf04-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf04-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF04_Bloodstone-Clay_4pk_Front_2D.png?v=1792768012&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-bloodstone-clay",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-bloodstone-clay",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-molten-ochre"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF05-MOLTEN-OCHRE.jpg?v=1792614488&width=400",
          "product_url": "/products/bloom_dpf05-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf05-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF05_Molten-Ochrey_4pk_Front_2D.png?v=1792768100&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-molten-ochre",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-molten-ochre",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-sun-relic"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF06-SUN-RELIC.jpg?v=1792614488&width=400",
          "product_url": "/products/bloom_dpf06-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf06-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF06_Sun-Relic_4pk_Front_2D.png?v=1792768176&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-sun-relic",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-sun-relic",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-burnished-earth"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF07-BURNISHED-EARTH.jpg?v=1792614489&width=400",
          "product_url": "/products/bloom_dpf07-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf07-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF07_Burnished-Earth_4pk_Front_2D.png?v=1792768234&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-burnished-earth",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-burnished-earth",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-acid-moss"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF08-ACID-MOSS.jpg?v=1792614490&width=400",
          "product_url": "/products/bloom_dpf08-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf08-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/4pk_Front_2D.png?v=1792764718&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-acid-moss",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-acid-moss",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-verdant-pulse"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF09-VERDANT-PULSE.jpg?v=1792614491&width=400",
          "product_url": "/products/bloom_dpf09-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf09-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF09_Verdant-Pulse_4pk_Front_2D.png?v=1792768309&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-verdant-pulse",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-verdant-pulse",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-mint-green"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF10-MINT-GREEN.jpg?v=1792614492&width=400",
          "product_url": "/products/bloom_dpf10-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf10-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF10_Mint-Green_4pk_Front_2D.png?v=1792768387&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-mint-green",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-mint-green",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-meadow-veil"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF11-MEADOW-VEIL.jpg?v=1792614493&width=400",
          "product_url": "/products/bloom_dpf11-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf11-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF11_Meadow-Veil_4pk_Front_2D.png?v=1792768474&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-meadow-veil",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-meadow-veil",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-emerald-forest"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF12-EMERALD-FOREST.jpg?v=1792614494&width=400",
          "product_url": "/products/bloom_dpf12-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf12-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF12_Emerald-Forest_4pk_Front_2D.png?v=1792768533&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-emerald-forest",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-emerald-forest",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-herbal-stone"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF13-HERBAL-STONE.jpg?v=1792614496&width=400",
          "product_url": "/products/bloom_dpf13-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf13-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF13_Herbal-Stone_4pk_Front_2D.png?v=1792768618&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-herbal-stone",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-herbal-stone",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-patina-teal"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF14-PATINA-TEAL.jpg?v=1792614496&width=400",
          "product_url": "/products/bloom_dpf14-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf14-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF14_Patina-Teal_4pk_Front_2D.png?v=1792768685&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-patina-teal",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-patina-teal",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-ultramarine-lift"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF15-ULTRAMARINE-LIFT.jpg?v=1792614497&width=400",
          "product_url": "/products/bloom_dpf15-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf15-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF15_Ultramarine-Lift_4pk_Front_2D.png?v=1792768757&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-ultramarine-lift",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-ultramarine-lift",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-prussian-depths"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF16-PRUSSIAN-DEPTHS.jpg?v=1792614498&width=400",
          "product_url": "/products/bloom_dpf16-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf16-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF16_Prussian-Depths_4pk_Front_2D.png?v=1792768816&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-prussian-depths",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-prussian-depths",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-mystic-plum"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF17-MYSTIC-PLUM.jpg?v=1792614499&width=400",
          "product_url": "/products/bloom_dpf17-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf17-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF17_Mystic-Plum_4pk_Front_2D.png?v=1792768880&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-mystic-plum",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-mystic-plum",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-lavender-ash"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF18-LAVENDER-ASH.jpg?v=1792614501&width=400",
          "product_url": "/products/bloom_dpf18-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf18-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF18_Lavender-Ash_4pk_Front_2D.png?v=1792768957&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-lavender-ash",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-lavender-ash",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-bloomed-violet"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF19-BLOOMED-VIOLET.jpg?v=1792614502&width=400",
          "product_url": "/products/bloom_dpf19-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf19-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF19_Bloomed-Violet_4pk_Front_2D.png?v=1792769027&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-bloomed-violet",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-bloomed-violet",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-royal-orchid"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF20-ROYAL-ORCHID.jpg?v=1792614503&width=400",
          "product_url": "/products/bloom_dpf20-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf20-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF20_Royal-Orchid_4pk_Front_2D.png?v=1792769085&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-royal-orchid",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-royal-orchid",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-desert-drift"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF21-ESERT-DRIFT.jpg?v=1792614505&width=400",
          "product_url": "/products/bloom_dpf21-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf21-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF21_Desert-Drift_4pk_Front_2D.png?v=1792769148&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-desert-drift",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-desert-drift",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-hearthgrain"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF22-HEARTHGRAIN_1.jpg?v=1792614505&width=400",
          "product_url": "/products/bloom_dpf22-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf22-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF22_Hearthgrain_4pk_Front_2D.png?v=1792769225&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-hearthgrain",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-hearthgrain",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-battlefield-soil"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF23-BATTLEFIELD-SOIL.jpg?v=1792614506&width=400",
          "product_url": "/products/bloom_dpf23-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf23-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/4pk_Front_2D_70febbcd-552d-438f-a215-64c762fc8236.png?v=1792765004&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-battlefield-soil",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-battlefield-soil",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-carbon-void-black"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · 2 oz",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_2D.png?v=1792764175&width=400",
          "product_url": "/products/bloom_dpf24-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf24-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color pack · 4 × 2 oz",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF24_Carbon-Void-Black_4pk_Front_2D.png?v=1792769279&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-carbon-void-black",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-carbon-void-black",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3><strong>Bloom color</strong></h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-Bloom-DPF02"] = window.MG_SWATCH_SETS["Sizes-Bloom-desert-petal"];

window.MG_SWATCH_SETS["Sizes-Bloom-kits"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 2,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 2,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 13,
      "text_size_desktop": 15,
      "border_radius_px": 6,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "custom_html": "<span hidden data-bloom-size-popup></span><style>.mgps-modal:has([data-bloom-size-popup]){position:fixed!important;inset:0!important;align-items:center!important;justify-content:center!important;padding:20px!important;overflow:hidden!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:min(900px,calc(100vw - 40px))!important;max-width:900px!important;max-height:calc(100dvh - 40px)!important;margin:0!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__body{max-height:calc(100dvh - 110px)!important;padding-bottom:12px!important;overflow-y:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-row:has([data-bloom-size-popup]){display:none!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:280px!important;aspect-ratio:auto!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner{align-items:center!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{height:100%!important;width:100%!important;max-height:280px!important;object-fit:contain!important;transform:none!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]){padding:16px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-modal__dialog{width:calc(100vw - 32px)!important;max-height:calc(100dvh - 32px)!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:180px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:180px!important}}</style><style>.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:140px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:140px!important}.mgps-modal:has([data-bloom-size-popup]){--mgps-text-size:14px}.mgps-modal:has([data-bloom-size-popup]) .mgps-row{margin-bottom:18px!important}@media(max-width:749px){.mgps-modal:has([data-bloom-size-popup]) .mgps-img-wrap{height:110px!important}.mgps-modal:has([data-bloom-size-popup]) .mgps-img-inner img{max-height:110px!important}}</style>",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row": 2,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Single bottle · choose color",
          "alt": "Single bottle · 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF01-GESSO-CLOUD-WHITE.jpg?v=1792614483&width=400",
          "product_url": "/products/bloom_dpf01-30_xxs",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom_dpf01-30_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Same-color four-pack · choose color",
          "alt": "Same-color pack · 4 × 2 oz",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DPF01_Gesso-Cloud-White_4pk_Front_2D.png?v=1792767745&width=400",
          "product_url": "/products/bloom-texture-paint-4pk-gesso-cloud-white",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-4pk-gesso-cloud-white",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Single color options</h3>",
      "subheading": "<p>Get a bundle of 4 and save</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 1,
      "swatches_per_row_desktop": 1,
      "swatches_per_row": 1,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Complete Set · 24 colors",
          "alt": "Complete Set · 24 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/CompleteKitMainPicture3D_800x800.png?v=1793664061",
          "product_url": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "desc_html": "<p>One 2 oz bottle of every color · 48 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bloom-texture-paint-complete-color-set-24-x-2-oz",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>All 24 colors</h3>",
      "subheading": "<p>The complete Bloom collection.</p>"
    },
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 2,
      "swatches_per_row_desktop": 3,
      "swatches_per_row": 3,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dreamy Pastels · 4 colors",
          "alt": "Dreamy Pastels · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_ebc4dd28-b6cf-4d12-9e9c-f02053c3485f_800x800.png?v=1792762351",
          "product_url": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/dreamy-pastels-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Hearth and Earth · 4 colors",
          "alt": "Hearth and Earth · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/7_ec3a3b43-37cf-4d1c-ab79-b9d1c4ee8663_800x800.png?v=1792762357",
          "product_url": "/products/heart-and-earth-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/heart-and-earth-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Luminous Spectrum · 4 colors",
          "alt": "Luminous Spectrum · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/1_c64f90c0-ef2f-4fd9-9ecc-0cb54747c5ba_800x800.png?v=1792762350",
          "product_url": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/luminous-spectrum-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Moss and Ruin · 4 colors",
          "alt": "Moss and Ruin · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/11_100f4e63-d7c4-491e-9573-2fea64ba9010_800x800.png?v=1792762347",
          "product_url": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/moss-and-ruin-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bold Expression · 4 colors",
          "alt": "Bold Expression · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/9_7b1925e8-b258-4dcb-ba03-bb50d0f3f9e4_800x800.png?v=1792762348",
          "product_url": "/products/bold-expression-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/bold-expression-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Deep Realm · 4 colors",
          "alt": "Deep Realm · 4 colors",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_535e1e05-2b1e-4f42-b058-c736c2963cf8_800x800.png?v=1792762347",
          "product_url": "/products/deep-realm-bloom-texture-paint-4-pack",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "<p>Four different 2 oz colors · 8 oz total</p>",
          "desc_html": "<p>Four different 2 oz colors · 8 oz total</p>",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/deep-realm-bloom-texture-paint-4-pack",
            "text": "Shop"
          }
        }
      ],
      "heading": "<h3>Curated color kits</h3>",
      "subheading": "<p>Four different colors in each kit.</p>"
    }
  ]
};

// Use the current product color or kit name in the Bloom size popup.
(function () {
  var context = document.getElementById("ri-bloom-size-context");
  if (!context) return;
  var name;
  try { name = JSON.parse(context.textContent); } catch (error) { return; }
  if (typeof name !== "string" || !name.trim()) return;
  var escapedName = name.replace(/[&<>"']/g, function (character) { return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[character]; });
  Object.keys(window.MG_SWATCH_SETS).forEach(function (key) {
    if (key.indexOf("Sizes-Bloom-") !== 0) return;
    var set = window.MG_SWATCH_SETS[key];
    if (!set || !set.rows || !set.rows[1]) return;
    set.rows[1].heading = "<h3><strong>" + escapedName + "</strong></h3>";
  });
})();
